
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {Kasse} from './kasse';


@Injectable()
export class SAService {

  constructor(private httpService: HttpClient) { }

error;
apiUrl: string = 'http://localhost:3000/get';
httpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json',
    // Authorization: 'ZG1nOmltbmF0MjM5',
  }),
};
  getKasse():Observable<Kasse[]> {
    return this.httpService.get<Kasse[]>('/bilgar/assets/sa-kasse.json')
    .pipe(
      tap(_ => this.log('fetched kasse')),
      catchError(this.handleError<Kasse[]>('getKasse', []))
    );
  }

  getKasse2() {
    this.apiUrl='http://localhost:3000/sa-kasse';
    return this.httpService.get<Kasse[]>(this.apiUrl, this.httpOptions)
    .pipe(
      tap(_ => this.log('fetched kasse')),
      catchError(this.handleError<Kasse[]>('getKasse', []))
    );
  }

  geteinnahmen():Observable<number> {

    return this.getKasse().pipe(
       map(einnahmen =>{
         return einnahmen
         .reduce((previous, current) =>previous +  current.einnahmen, 0);

       })
    );
  }
  log(ewe){
    
   console.log(ewe)

  }


  

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}



